import { ReactNode } from 'react'
import styled, { css } from 'styled-components'

import { WorkshopError } from '@/components/Icons'

export enum BannerTypes {
  warning = 'warning',
  error = 'error',
  informational = 'informational'
}

type BannerProps = {
  type: BannerTypes
  children: ReactNode
  noIcon?: boolean
  className?: string
  onClick?: () => void
}

const StyledBanner: any = styled.div`
  ${({ type }: any) => {
    switch (type) {
      case BannerTypes.warning: {
        return css`
          background: var(--wg-orange);

          & * {
            color: #ffffff;
          }
        `
      }
      case BannerTypes.error: {
        return css`
          background: var(--wg-red);

          & * {
            color: #ffffff;
          }
        `
      }
      case BannerTypes.informational: {
        return css`
          background: var(--wg-blue-link);

          & * {
            color: #ffffff;
          }
        `
      }
    }
  }}
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  padding: 8px;

  & * {
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
`

// TODO Fix the WorkshopError icon
const StyledIcon = styled(WorkshopError)`
  width: 1rem;
  height: 1rem;
  margin: 0 5px;
`

const Banner = ({ children, type, noIcon = false, className = '', onClick }: BannerProps) => {
  let Icon = WorkshopError
  switch (type) {
    case 'warning': {
      Icon = WorkshopError
      break
    }
    case 'error': {
      Icon = WorkshopError
      break
    }
    case 'informational': {
      // TODO add an informational icon
      Icon = WorkshopError
    }
  }
  return (
    <StyledBanner className={`banner ${className || ''}`} type={type} onClick={onClick}>
      {!noIcon && <StyledIcon as={Icon} />}
      {children}
    </StyledBanner>
  )
}

Banner.displayName = 'Banner'

export default Banner
